import React from "react";
import PayTypesSection from "./PayTypesSection";

// The set of expense types a company admin can build default expenses from.
// Each entry carries a human-readable label, a plain-language description of how
// the expense is applied, and the default legal document text used when the
// expense type is referenced in a rep's agreement.
const EXPENSE_TYPES = [
  {
    value: "BACKEND_PERCENTAGE",
    label: "Backend Percentage",
    description:
      "A percentage-based expense deducted from backend pay. The configured percentage is applied to the rep's backend earnings.",
    documentText:
      "An expense equal to the specified percentage shall be deducted from the Representative's backend compensation for each applicable account.",
  },
  {
    value: "BACKEND_FIXED_AMOUNT",
    label: "Backend Fixed Amount",
    description:
      "A fixed dollar amount deducted from backend pay. The same amount is deducted regardless of the size of the rep's backend earnings.",
    documentText:
      "A fixed expense in the amount specified shall be deducted from the Representative's backend compensation for each applicable account.",
  },
  {
    value: "FRONTEND_RECURRING",
    label: "Frontend Recurring",
    description:
      "A recurring expense deducted from frontend pay on an ongoing basis for the duration of the applicable period.",
    documentText:
      "A recurring expense in the amount specified shall be deducted from the Representative's frontend compensation on a recurring basis for the duration of the applicable period.",
  },
];

function ExpenseTypesList({ companyTypes, onTypesChange }) {
  return (
    <PayTypesSection
      intro="The following expense types are available when configuring default expenses."
      types={EXPENSE_TYPES}
      companyTypes={companyTypes}
      endpoint="expense"
      onTypesChange={onTypesChange}
    />
  );
}

export default ExpenseTypesList;
